export class StudentsState {
    public students: string[] = []
    public streamId: string
}


// WEBPACK FOOTER //
// ./src/components/stream/students/StudentsState.ts